import { getFormDefinition, createFormDataFromItem, createItemFromFormData } from './form';
import { entityToStore } from '@/utils/store';
import baseCrudMixin from '@/mixins/crud';
export default {
  computed: {
    definition() {
      return this.createDefinition();
    },
    entityStore() {
      return entityToStore(this.entity);
    }
  },
  mixins: [baseCrudMixin],
  data: () => ({
    isEdit: true,
    entity: 'FabricStockReport',
    returnTo: 'home',
    injectFormValues: {}
  }),
  created() {
    this.$store.dispatch('stockLocation/getItems');
  },
  methods: {
    createDefinition() {
      return getFormDefinition(this);
    },
    createFormDataFromItem,
    createItemFromFormData,
    getStockLocationsToReport(form) {
      let selectedStockLocations = [];
      if (!form.stockLocations || form.stockLocations.length === 0) {
        selectedStockLocations = this.$store.getters['stockLocation/loadedItems'];
      } else {
        form.stockLocations.forEach(stockLocationID => {
          const stockLocation = this.$store.getters['stockLocation/getLoadedItemByID'](stockLocationID);
          if (stockLocation) {
            selectedStockLocations.push(stockLocation);
          }
        });
      }
      return selectedStockLocations;
    },
    async createStockReport() {
      const form = this.$store.getters['editor/flattenedForm'];
      const createReportCommand = {
        selectedStockLocationIDs: form.stockLocations ? form.stockLocations : [],
        fabricStatusOptionsSelected: form.fabricStatusOption ? form.fabricStatusOption : []
      };
      const stockReportData = await this.$store.dispatch('fabricStockReport/createStockReport', createReportCommand);
      if (stockReportData) {
        this.injectFormValues = Object.assign({}, { stockReportData: stockReportData });
      }
      this.$refs.editor.handleActivateTab('stockReportData');
    }
  }
};
